module.exports = __webpack_public_path__ + "img/machin_l.6414518f.png";